/* eslint-disable camelcase */
import React, { useState, useEffect, Fragment } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import _ from 'lodash';
import moment from 'moment';
import ReactLoading from 'react-loading';
import { IconContext } from 'react-icons';
import { MdSettings } from 'react-icons/md';
import moreIcon from '../../../images/more.png';
import {
  dustBag,
  boxHandbag,
  convertToRupiah,
  ADMINISTRATOR,
  DISBURSEMENT,
  ON_DONE,
  SENT_KICK,
  WAREHOUSE,
  _DONE_BY_ADMIN,
  _DONE_BY_BUYER,
  _DONE_BY_CRON,
  _KA_RECEIVED,
  _KA_RETURN,
  _NEW,
  _ON_CANCEL,
  _SELLER_SENT,
  _SENT_BUYER,
  _VERIFIED_FAIL,
  _VERIFIED_PASS,
  formatCurrencyWithMinus
} from '../../../utils';
import {
  sneakersCondition,
  accessoriesCondition,
  handbagCondition,
  boxCondition,
  defectCondition,
  handleImageCategory,
  formatCurrency,
  yellowing,
  displayItem,
  sneakersDefect,
} from '../../../utils/Helpers';
import TableHeader from '../components/TableHeader';

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
import AuthInterface from '../../../interface/reducers/auth';
import DataHistoryInterface, {
  PenjualanInterface,
  DataPenjualanProgressInterface,
} from '../../../interface/reducers/history';
import { SaleInterface } from '../../../interface/bid';
// ====== end of interface import section ====== //

import EMPTY_STATE from '../../../images/dashboard-empty-state.jpg';
import HOLIDAY_MODE from '../../../images/holidaymode1024.png';
import WARNING_ICON from '../../../images/warning-orange.png';
import HOLIDAY_ICON_RED from '../../../images/holiday-icon-red.png';
import { actionSellerSell } from '../../../actions/dashboardAction';
import { getTransactionTimeline } from '../../../actions/saleActions';
import { doFetchProfile } from '../../../actions/authAction';
import ModalInProgressSelling from '../components/ModalInProgressSelling';
import ModalAWBV3 from '../../Modals/ModalAWBV3';
import { ModalAlert, ModalConfirmationSale, ModalShipper } from '../../Modals';
import CreditMinus from './components/CreditMinus';
import Suspended from "./components/Suspended";

export const getStatusProcessRiwayat = (
  { id, status, seller_responded, money_disbursed }: SaleInterface,
  isSeller = true,
) => {
  switch (status) {
    // case _NEW[0]: return seller_responded ? SENT_KICK : this._renderButton(seller_responded, id)
    case _NEW[0]:
      return seller_responded ? SENT_KICK[1] : 'Needs Sales Confirmation';
    case _SELLER_SENT[0]:
      return WAREHOUSE[1];
    case _KA_RECEIVED[0]:
      return isSeller ? _KA_RECEIVED[2] : _KA_RECEIVED[1];
    case _VERIFIED_PASS[0]:
      return isSeller ? _VERIFIED_PASS[3] : _VERIFIED_PASS[2];
    case _SENT_BUYER[0]:
      return isSeller ? _VERIFIED_PASS[3] : _SENT_BUYER[2];
    case _DONE_BY_ADMIN:
      return money_disbursed ? ON_DONE[1] : DISBURSEMENT[1];
    case _DONE_BY_BUYER:
      return money_disbursed ? ON_DONE[1] : DISBURSEMENT[1];
    case _DONE_BY_CRON:
      return money_disbursed ? ON_DONE[1] : DISBURSEMENT[1];
    case _VERIFIED_FAIL[0]:
      return _VERIFIED_FAIL[2];
    case _ON_CANCEL[0]:
      return _ON_CANCEL[2];
    case _KA_RETURN[0]:
      return _KA_RETURN[2];
    default:
      return ADMINISTRATOR[1];
  }
};

const moreIconNew: any = moreIcon;

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataAuth: AuthInterface;
};

interface InProgressInterface {
  dataSelling: PenjualanInterface;
  roles: string[];
  ratio: number;
  currency: string;
  isHoliday: boolean;
  callbackAfterUpdate: (...args: any) => any;
  loading: boolean;
  timeline: any;
  userdata: any;
  dataAuth: any;
  setIsOpenModalAlert: () => any;
  doActionSeller: (action: boolean, id: number) => Promise<any>;
  getTransactionTimeline: (params: any) => Promise<any>;
  getProfile: () => Promise<any>;
}

/**
 * InProgress tab on Selling User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {InProgressInterface} props for this component.
 * @return {JSX.Element}
 */
function InProgressTab({
  dataSelling,
  roles,
  ratio,
  currency,
  isHoliday,
  doActionSeller,
  callbackAfterUpdate,
  loading,
  getTransactionTimeline,
  timeline,
  getProfile,
  userdata,
  dataAuth,
  setIsOpenModalAlert,
  freeCancel,
  email,
  seller_points
}: InProgressInterface): JSX.Element {
  const hasSuspendedSeller = dataAuth?.userdata?.roles?.includes('suspended_seller');
  const sellerPointsLessThanFive = parseInt(seller_points) < 5;
  const isSuspended = hasSuspendedSeller || sellerPointsLessThanFive;

  const isSellerCreditMinus = parseInt(dataAuth?.userdata?.balance_with_fee ?? "0") < 0;
  const [isSubmittingAccept, setSubmittingAccept] = useState(false);
  const [isSubmittingDecline, setSubmittingDecline] = useState(false);

  const [isModalOpened, setModalOpened] = useState(false);
  const [isModalAWBOpened, setModalAWBOpened] = useState(false);
  const [useXIcon, setUseXIcon] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [isOpenModalConfirmation, setIsOpenModalConfirmation] = useState(false)

  const [openModalWarning, setOpenModalWarning] = useState(false);
  const [modalType, setModalType] = useState<'accept' | 'decline'>('accept');
  const [saleId, setSaleId] = useState(0);
  const [bodyText, setBodyText] = useState('');
  const [headerText, setHeaderText] = useState('');
  const [penaltyAmount, setPenaltyAmount] = useState('');

  const modalWarningToggle = () => setOpenModalWarning(!openModalWarning);

  useEffect(() => {
    const params = {
      params: { name: 'transaction_timeline' },
    };

    getTransactionTimeline(params);
  }, []);

  const getShipperDetails = () => {
    try {
      if (!selectedData.hasOwnProperty('sale')) return null;
      if (!selectedData.sale?.length) return null;

      return selectedData.sale[0].shipper;
    } catch (err) {
      console.log(err, "Error fn shipperDataHandler file SellingTabs/InProgress.tsx")
      return null;
    }
  }

  const isSelectMethod = (item) => {
    const { status = "" } = item.shipper || {}
    if (!status) return true;

    return false;
  }

  const isSelectScheduled = (item) => {
    const { status = "" } = item.shipper || {}
    if (status === "NEW") return true;

    return false;
  }

  const trackingNumberHandler = (item) => {
    setModalAWBOpened(true);
    setSelectedData(item);
  }

  const renderInProgressStatus = (item) => {
    const isConfirmSale = getStatusProcessRiwayat(item.sale[0], true) === 'Needs Sales Confirmation';
    const isShipper = item.sale[0]?.shipper;
    const sellerResponded = item.sale[0].seller_responded
    const saleStatusNew = item.sale[0].status === _NEW[0]

    const _renderStats = <p className={'status normal'}>{getStatusProcessRiwayat(item.sale[0], true)}</p>
    const _renderSold = <Fragment>
      <p className={'normal'}>SOLD</p>
      <p>{formatCurrency(item.offer_amount, ratio, currency)}</p>
    </Fragment>

    if(sellerResponded) {
      if(saleStatusNew){
        if(!isShipper) {
          return _renderSold
        }

        if(isShipper?.status != "NEW"){
          return _renderStats
        }
        return _renderSold
      } else {
        return _renderStats
      }
    } else {
      return _renderSold
    }
  }

  const renderStatuDetail = (item, insertAWB) => {
    const isConfirmSale = getStatusProcessRiwayat(item.sale[0], true) === 'Needs Sales Confirmation';

    const showTrackButton = () => {
      const usingShipper = item.sale[0]?.shipper?.status;
      if (!usingShipper) return false
      if (
        (item.sale[0].status == "SELLER_SENT" || item.sale[0].status == "NEW") &&
        usingShipper !== "NEW"
      ) return true

      return false
    }

    return <div className='action-and-details'>
      {isConfirmSale && <p className={'status normal'}>
        {getStatusProcessRiwayat(item.sale[0], true)}
      </p>}
      {insertAWB &&
        item.sale[0].status === _NEW[0] &&
        item.sale[0].seller_responded !== null && (
          (isSelectMethod(item.sale[0]) || isSelectScheduled(item.sale[0]))) ?
        <>
          <div
            className={'button'}
            onClick={() => {
              setModalAWBOpened(true);
              setSelectedData(item);
              setUseXIcon(true);
            }}
          >
            {isSelectScheduled(item.sale[0]) ? <p>Schedule a Pick-up</p> : <p>Select delivery method</p>}
          </div>
          {
            !isSelectScheduled(item.sale[0]) ? (
              <div className={'bottom-status'}>
                <KickImage
                  src={WARNING_ICON}
                  style={{
                    width: '15px',
                    height: '15px',
                  }}
                />

                <p>
                  Auto Cancel In{' '}
                  <span>
                    {moment(
                      moment(
                        item.sale[0] && item.sale[0].seller_responded,
                      ).valueOf() +
                      (timeline &&
                        timeline.waiting_seller_awb &&
                        timeline.waiting_seller_awb.time &&
                        timeline.waiting_seller_awb.time * 3600000),
                    ).diff(moment(), 'hours') >= 0
                      ? moment(
                        moment(
                          item.sale[0] && item.sale[0].seller_responded,
                        ).valueOf() +
                        (timeline &&
                          timeline.waiting_seller_awb &&
                          timeline.waiting_seller_awb.time &&
                          timeline.waiting_seller_awb.time * 3600000),
                      ).diff(moment(), 'hours')
                      : 0}
                  </span>{' '}
                  Hours
                </p>
              </div>
            ) : null
          }
        </>
        :
        showTrackButton() ?
          <div className={'button'} onClick={() => trackingNumberHandler(item)}><p>Track Package</p></div>
          : null
      }

      {isConfirmSale && (
        <>
          <div className={'action'}>
            <div
              className={'confirm'}
              onClick={() => {
                setIsOpenModalConfirmation(true)
                setModalType('accept');
                // modalWarningToggle();
                setSaleId(item.sale[0].id);
                setPenaltyAmount(formatCurrencyWithMinus(parseInt(item.penalty_amount), ratio, currency));
              }}
            >
              <p>Confirm</p>
            </div>
            <div
              className={'reject'}
              onClick={() => {
                setIsOpenModalConfirmation(true)
                setModalType('decline');
                // modalWarningToggle();
                setSaleId(item.sale[0].id);
                setPenaltyAmount(formatCurrencyWithMinus(parseInt(item.penalty_amount), ratio, currency));
              }}
            >
              <p>Reject</p>
            </div>
          </div>
          <div className={'bottom-status'}>
            <KickImage
              src={WARNING_ICON}
              style={{
                width: '15px',
                height: '15px',
              }}
            />
            <p>
              Auto Cancel In{' '}
              <span>
                {moment(
                  moment(
                    item.sale[0] && item.sale[0].customer_paid,
                  ).valueOf() +
                  (timeline &&
                    timeline.outstanding_confirmation &&
                    timeline.outstanding_confirmation.time &&
                    timeline.outstanding_confirmation.time * 3600000),
                ).diff(moment(), 'hours') >= 0
                  ? moment(
                    moment(
                      item.sale[0] && item.sale[0].customer_paid,
                    ).valueOf() +
                    (timeline &&
                      timeline.outstanding_confirmation &&
                      timeline.outstanding_confirmation.time &&
                      timeline.outstanding_confirmation.time *
                      3600000),
                  ).diff(moment(), 'hours')
                  : 0}
              </span>{' '}
              Hours
            </p>
          </div>
        </>
      )}
    </div>
  }

  /**
   * Table item for In Progress List in Selling Dashboard
   * @param {DataPenjualanProgressInterface} item
   * @return {JSX.Element}
   */
  function renderItem(item: DataPenjualanProgressInterface): JSX.Element {
    const uniqueDefects = _.uniqBy(item?.user_sell?.defects, 'name');
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG')
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = item?.user_sell?.product_variant?.hide_box_info;
    const statusOrderMasuk =
      getStatusProcessRiwayat(item.sale[0], true) ===
      'Needs Sales Confirmation';

    const insertAWB =
      getStatusProcessRiwayat(item.sale[0], true) === WAREHOUSE[1];
    const handleClickedDetail = () => {
      setSelectedData(item);
      setModalOpened(true);
    };

    const category = item?.sale?.[0]?.sale_product?.category_name;
    const isTicket = item?.user_sell?.product_variant?.product?.name.includes('Ticket');

    return (
      <div
        className={`item-table in-progress-table ${statusOrderMasuk ? '' : 'no-status'
          }`}
      >
        <div className={'product-container in-progress'}>
          <KickImage
            src={handleImageCategory(isTicket, category.toLowerCase())}
            className={'image-category'}
          />
          <div>
            <p className={'title'}>
              {item?.user_sell?.product_variant?.display_name}
            </p>
            {category === 'handbags' ||
            (category === 'lifestyles' &&
              item?.sale[0].sale_product?.size?.US.toLowerCase() !== 'all size') ? (
              <div className={'size-container'}>
                <p>{item?.sale[0].sale_product?.size?.US}</p>
              </div>
            ) : (
              <div className={'size-container'}>
                <p>US {item?.sale[0].sale_product?.size?.US}</p>
              </div>
            )}
            <p className={'condition'}>{item.invoice_number}</p>
            <p className={'extra'}>
              {item?.user_sell?.product_variant?.colour}
            </p>
            <p className={'extra'}>
              Consignment ID:{' '}
              {item?.sale[0].sale_product?.consignment_id ?? '-'}
            </p>
          </div>
        </div>
        <div className='status-action-wrapper'>
          <div className={'price-progress-container'}>
            {renderInProgressStatus(item)}
          </div>

          <div className={'status-progress-container'}>
            {renderStatuDetail(item, insertAWB)}
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-container'} onClick={handleClickedDetail}>
                {/* <MdSettings /> */}
                <KickImage src={moreIconNew} alt="..." />
              </div>
            </IconContext.Provider>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Rendering Empty State UI
   * @return {JSX.Element}
   */
  function renderEmpty() {
    return (
      <div className={'empty-container'}>
        <KickImage src={EMPTY_STATE} />
        <p>It seems you haven’t got anything on sale process.</p>
        <div className={'button-refresh'} onClick={callbackAfterUpdate}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  /**
   * Rendering Holiday Mode UI
   * @return {JSX.Element}
   */
  function renderHoliday() {
    return (
      <>
        {
          /* Uncomment to Render suspended if needed in future
          isSuspended ?
            <Suspended onClick={() => setIsOpenModalAlert()} />
            :
          */
          !isSellerCreditMinus ? (
            <div className={'empty-container'}>
              <KickImage src={HOLIDAY_MODE} />
              <p className={'title'}>Holiday mode is currently set to active</p>
              <p className={'bottom-text'}>
                All your listings are being temporarily deactivated. You can
                anytime re-activate your listings. Enjoy your break!
              </p>
            </div>
          ) : (
            <CreditMinus onClick={() => setIsOpenModalAlert()} />
          )
        }
      </>
    );
  }

  return (
    <div>
      <TableHeader
        getData={callbackAfterUpdate}
        type={'in progress'}
        mode={'selling'}
        isHoliday={isHoliday}
      />
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container'}>
            <span>Product</span>
          </div>
          <div className={'status-seller-progress-container'}>
            <span>Status</span>
          </div>
        </div>
        <div className={'body-table'}>
          {/* {isHoliday || isSuspended ? ( */}
          {isHoliday ? (
            renderHoliday()
          ) : dataSelling.isFetch || loading ? (
            <div className={'empty-container'}>
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            </div>
          ) : dataSelling.dataPenjualan.length ? (
            dataSelling.dataPenjualan.map((item) => renderItem(item))
          ) : (
            renderEmpty()
          )}
        </div>
      </div>
      <ModalInProgressSelling
        isOpen={isModalOpened}
        onToggle={() => setModalOpened(false)}
        callbackAfterUpdate={callbackAfterUpdate}
        data={selectedData}
        confirmationText={`Please deliver the goods ASAP and input the AWB  on your Seller Dashboard. Please ensure you’ve read the instructions we’ve sent to your email ${userdata?.typed_email}`}
        toggleAWB={() => {
          setModalOpened(false)
          setModalAWBOpened(true);
        }}
      />
      <ModalAlert
        isOpen={false}
        onToggle={modalWarningToggle}
        title={modalType === 'accept' ? 'Accept Offer' : 'Decline Offer'}
        contentText={
          modalType === 'accept'
            ? 'Are you sure want to accept this offer?'
            : 'Are you sure you want to decline this offer?'
        }
        showButton
        onSubmit={() => {
          if (modalType === 'decline') {
            setSubmittingDecline(true);
            doActionSeller(false, saleId).then(() => {
              getProfile();
              callbackAfterUpdate();
              modalWarningToggle();
              setSubmittingDecline(false);
            });
          } else {
            setSubmittingAccept(true);
            doActionSeller(true, saleId).then(() => {
              callbackAfterUpdate();
              modalWarningToggle();
              setSubmittingAccept(false);
            });
          }
        }}
        disabled={isSubmittingAccept || isSubmittingDecline}
        isLoading={isSubmittingAccept || isSubmittingDecline}
      />
      <ModalConfirmationSale
        cancelAction={() => {
          setIsOpenModalConfirmation(false);
        }}
        yesAction={() => {
          if (modalType === 'decline') {
            setSubmittingDecline(true);
            doActionSeller(false, saleId).then(() => {
              getProfile();
              callbackAfterUpdate();
              modalWarningToggle();
              setSubmittingDecline(false);
              setIsOpenModalConfirmation(false);
            });
          } else {
            setSubmittingAccept(true);
            doActionSeller(true, saleId).then(() => {
              callbackAfterUpdate();
              modalWarningToggle();
              setSubmittingAccept(false);
              setIsOpenModalConfirmation(false);
            });
          }
        }}
        //@ts-ignore
        disabled={isSubmittingAccept || isSubmittingDecline}
        isLoading={isSubmittingAccept || isSubmittingDecline}
        headerText={headerText}
        bodyText={bodyText}
        isOpen={isOpenModalConfirmation}
        modalType={modalType}
        freeCancel={freeCancel}
        email={email}
        seller_points={seller_points}
        penaltyAmount={penaltyAmount}
      />
      {/* <ModalAWBV3
        isOpen={isModalAWBOpened}
        onToggle={() => {
          setModalAWBOpened(false);
          setUseXIcon(false);
        }}
        title={'Input AWB Number'}
        saleId={
          selectedData.hasOwnProperty('sale') ? selectedData.sale[0].id : 0
        }
        reFetchData={callbackAfterUpdate}
        useXIcon={useXIcon}
      /> */}
      {isModalAWBOpened ?
        <ModalShipper
          isOpen={isModalAWBOpened}
          ratio={ratio}
          currency={currency}
          seller_responded={selectedData.hasOwnProperty('sale') ? selectedData.sale[0].seller_responded : ""}
          submitDropoff={() => {
            callbackAfterUpdate();
            setModalAWBOpened(false);
          }}
          onHideAndUpdate={() => {
            callbackAfterUpdate();
            setModalAWBOpened(false);
          }}
          onHide={() => {
            setModalAWBOpened(false);
          }}
          sale_id={
            selectedData.hasOwnProperty('sale') ? selectedData.sale[0].id : 0
          }
          shipperData={getShipperDetails()}
        />
        : null
      }
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataSelling: state.dataHistory.pending,
    roles: state.dataAuth.userdata.roles,
    email: state.dataAuth.userdata.email,
    freeCancel: state.dataAuth.userdata.free_cancel,
    seller_points: state.dataAuth.userdata.seller_points,
    ratio: state.dataAuth.userCurrency.ratio,
    currency: state.dataAuth.userCurrency.currency,
    userdata: state.dataAuth.userdata,
    isHoliday: state.dataAuth.userdata.is_holiday,
    timeline: state.dataSelling.timeline.data,
    dataAuth: state.dataAuth
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doActionSeller: (action: boolean, id: number) =>
      dispatch(actionSellerSell(action, id)),
    getTransactionTimeline: (params) =>
      dispatch(getTransactionTimeline(params)),
    getProfile: () => dispatch(doFetchProfile()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InProgressTab);
